<template>
  <VpListLayout add-route="contact" feature="CONTACT">
    <VpList
      :per-page="10"
      :columns="columns"
      endpoint="cardContacts"
      cache="cardContacts"
      :request-payload="{
        query: $options.cardContacts,
      }"
      class="vp-h-full"
      ref="list"
      title="Contacts"
      feature="CONTACT"
      @rowClick="
        $router.push({
          name: 'contact',
          params: {
            id: $event.id,
          },
        })
      "
      reorder
      :params="{ cardId: Number($route.params.cardId) }"
      @reorder="
        reorder('cardContacts', $event, {
          cardId: Number($route.params.cardId),
        })
      "
    >
      <template #empty>
        <VpFeature the-key="CONTACT" #default="{ feature }">
          <VpListEmpty :feature="feature" route="contact" />
        </VpFeature>
      </template>

      <template #profilePicture="{ item }">
        <VpAvatar
          class="vp-rounded-md"
          :image="item.profilePicture?.size._200x200"
          :name="item.name && item.name.length ? item.name : '#'"
          size="sm"
        />
      </template>

      <template #name="{ item }">
        <p>{{ item.name }}</p>
        <p class="vp-text-sm vp-text-gray-500">{{ item.designation }}</p>
      </template>

      <template #status="{ item }">
        <VpStatus :value="item.status" />
      </template>
    </VpList>
  </VpListLayout>
</template>

<script>
import reorder from "mixins/reorder.js";
import { Call, Whatsapp } from "icons/icons.js";
import cardContacts from "./collection.gql";

export default {
  cardContacts,
  icons: {
    Call,
    Whatsapp,
  },
  mixins: [reorder],
  computed: {
    columns() {
      return [
        { name: "_index", label: "#", fix: true },
        { name: "profilePicture", label: "Photo", fix: true, type: "string" },
        { name: "name", type: "string" },
        {
          name: "mobile",
          type: "string",
          value(row) {
            return row.mobileNumber?.internationalFormat || row.mobile;
          },
        },
        { name: "email", type: "string" },
        { name: "status", fix: true, type: "string" },
      ];
    },
  },
};
</script>
